import { useDispatch, useSelector } from 'react-redux';
import { getSignupDataValue, getSignupDataGtkmData } from '../store/signup-data/selectors';
import { Data } from 'signup-constants/signupData/Data';
import { retryEndpoint } from '../store/http-responses/action-creators';
import { EndpointKey } from '../http/EndpointKey';
import { getEndpointRetries } from '../store/http-responses/selectors';
import { useCurrentStep } from './useCurrentStep';
import { useIsStepDataValid } from './useIsStepDataValid';
import { updateStepOrdersInDomainStep } from '../http-gtkm-company-info/updateStepOrders';
import { setGtkmAnimationStart, setGtkmShowingErrorModal, setGtkmAnimationShowingCount, setGtkmHasDomainChangedInDomainStep } from '../store/gtkm/action-creator';
import { getGtkmAnimationState, getGtkmAnimationShowingCount } from '../store/gtkm/selector';
import { GtkmAnimationState } from '../store/gtkm/types';
import { useView } from '../views/useView';
import { Step } from 'signup-constants/Step';
export const hasGTKMDomainChanged = state => {
  const companyDomain = getSignupDataValue(state, Data.CompanyDomain);
  let gtkmCompanyDomain = getSignupDataGtkmData(state, Data.CompanyDomain);
  if (gtkmCompanyDomain === 'hubspot.com') {
    gtkmCompanyDomain = 'hubspot-test.com';
  }
  return gtkmCompanyDomain !== companyDomain;
};
export const useHasDomainChanged = () => {
  const appState = useSelector(state => state);
  return hasGTKMDomainChanged(appState);
};
export const useGTKMDomainSubmit = () => {
  const dispatch = useDispatch();
  const hasDomainChanged = useHasDomainChanged();
  const {
    currentStep
  } = useCurrentStep();
  const isStepDataValid = useIsStepDataValid(currentStep);
  const gtkmDomain = useSelector(state => getSignupDataGtkmData(state, Data.CompanyDomain));
  const animationState = useSelector(state => getGtkmAnimationState(state));
  const animationShowingCount = useSelector(state => getGtkmAnimationShowingCount(state));
  const {
    submit
  } = useView({
    stepKey: Step.CompanyDomain
  });
  const appState = useSelector(state => state);
  const gtkmEndpointRetries = useSelector(state => getEndpointRetries(state, EndpointKey.GTKMCompanyInfo));
  const haveNotInvokedSecondGTKMAPI = gtkmEndpointRetries < 1;
  const handleSubmit = () => {
    dispatch(setGtkmShowingErrorModal(false));
    dispatch(setGtkmHasDomainChangedInDomainStep(hasDomainChanged));
    // In the following cases, we don't want to show the animation and hope just to go to next step directly
    // 1. The second GTKM API have been invoked
    // 2. The domain hasn't changed but already shown the animation once
    if (!haveNotInvokedSecondGTKMAPI || !hasDomainChanged && animationShowingCount >= 1) {
      submit();

      // When the domain has changed and we haven't invoked the second GTKM API,
      // we want to show the animation and retry the second GTKM API
    } else if (hasDomainChanged && haveNotInvokedSecondGTKMAPI) {
      dispatch(setGtkmAnimationStart());
      dispatch(setGtkmAnimationShowingCount(animationShowingCount + 1));
      dispatch(retryEndpoint(EndpointKey.GTKMCompanyInfo));

      // When the domain has not been changed and we haven't invoked the second GTKM API,
      // we want to show the animation and update the step orders
    } else {
      dispatch(setGtkmAnimationStart());
      dispatch(setGtkmAnimationShowingCount(animationShowingCount + 1));
      updateStepOrdersInDomainStep({
        gtkmData: {
          [Data.CompanyDomain]: gtkmDomain
        },
        dispatch,
        state: appState
      });
    }
  };
  return {
    handleSubmit,
    nextButtonEnabled: isStepDataValid && animationState !== GtkmAnimationState.Started
  };
};